<template>
	<div class="pl10 mt20">
		<span class="dib">税务信息</span><span class="line"></span>
		<div class="mt20">
			<el-form :model="financeData" label-width="207px" class="demo-ruleForm">

				<!-- 纳税人识别号 -->
				<el-form-item label="纳税人识别号：">
					<span>{{ financeData.taxpayerRegistrationCode }}</span>
					<span class="main_word" v-if="snapshot.taxpayerRegistrationCode">&nbsp;&nbsp; {{ snapshot.taxpayerRegistrationCode }}</span>
				</el-form-item>

				<!-- 纳税人类型 -->
				<el-form-item label="纳税人类型：" class="mt20">
					<span v-if="financeData.taxpayerType == 1">一般纳税人</span>
					<span v-if="financeData.taxpayerType == 2">小规模纳税人</span>
					<span class="main_word" v-if="snapshot.taxpayerType == 1">&nbsp;&nbsp; 一般纳税人</span>
					<span class="main_word" v-if="snapshot.taxpayerType == 2">&nbsp;&nbsp; 小规模纳税人</span>

				</el-form-item>
				<el-form-item v-if="financeData.taxpayerType == 1" label="一般纳税人资格认定表：" prop="generalTaxpayerFile">
					<div>
						<img @click="previewPic($event)" v-for="gtFile in financeData.generalTaxpayerFile.split(',')" class="pic_skan"
							 :src="gtFile">
						<img @click="previewPic($event)" class="pic_skan_red" v-for="sgtFile in snapshot.generalTaxpayerFile.split(',')"
							 v-if="sgtFile" :src="sgtFile">
					</div>
				</el-form-item>
				<span class="dib">货款支付账户</span><span class="second_line"></span>
				<!-- 银行开户名 -->
				<el-form-item label="银行开户名：">
					<span>{{ financeData.accountName }}</span>
					<span class="main_word" v-if="snapshot.accountName">&nbsp;&nbsp; {{ snapshot.accountName }}</span>
				</el-form-item>
				<!-- 银行帐号 -->
				<el-form-item label="银行帐号：">
					<span>{{ financeData.accountNumber }}</span>
					<span class="main_word" v-if="snapshot.accountNumber">&nbsp;&nbsp; {{ snapshot.accountNumber
						}}</span>
				</el-form-item>
				<!-- 开户银行 -->
				<el-form-item label="开户银行：">
					<span>{{ financeData.bankName }}</span>
					<span class="main_word" v-if="snapshot.bankName">&nbsp;&nbsp; {{ snapshot.bankName }}</span>
				</el-form-item>
				<!-- SwiftCode -->
				<el-form-item v-if="financeData.registeredCountry != 1" label="SwiftCode：">
					<span>{{ financeData.swiftCode }}</span>
					<span class="main_word" v-if="snapshot.swiftCode">&nbsp;&nbsp; {{ snapshot.swiftCode }}</span>
				</el-form-item>
				<!-- 省 -->
				<el-form-item v-if="financeData.registeredCountry == 1" label="省：">
					<span>{{ financeData.province }}</span>
					<span class="main_word" v-if="snapshot.province">&nbsp;&nbsp; {{ snapshot.province}}</span>
				</el-form-item>
				<!-- 市 -->
				<el-form-item v-if="financeData.registeredCountry == 1" label="市：">
					<span>{{ financeData.city }}</span>
					<span class="main_word" v-if="snapshot.city">&nbsp;&nbsp; {{ snapshot.city }}</span>
				</el-form-item>
			</el-form>
			<!--预览图片-->
			<el-dialog :visible.sync="dialogVisible" size="small">
				<img  width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
            return {
				// 图片预览
				dialogImageUrl: '',
				dialogVisible: false,
                generalTaxpayerFileArray:[],
                financeData:{
                    generalTaxpayerFile:"",
                    // status : 2
				},
                snapshot:{
                    generalTaxpayerFile:""
				},
                supplierApplyId : 0
            };
		},
		methods: {
            initFinanceInfo(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findFinancialInfoAndSnapshot',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.financeData = result.data.lastest;
                            if(!that.financeData.generalTaxpayerFile) {
                                that.financeData.generalTaxpayerFile = "";
                            }
                            // that.financeData.status = 2;
                            that.snapshot = result.data.snapshot;
                            if(that.snapshot) {
								if(!that.snapshot.generalTaxpayerFile) {
                                    that.snapshot.generalTaxpayerFile = "";
                                }
                            }
                        }  else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			}
		},

		mounted () {
            var supplierApplyId = this.$route.query.supplierApplyId;
            this.initFinanceInfo(supplierApplyId);
        },
	}
</script>

<style type="text/css" lang="less" scoped>
	.line {
		margin-left: 3%;
		display: inline-block;
		width: 91%;
		height: 1px;
		border-bottom: 1px dashed #999;
		vertical-align: middle;
	}
	.second_line {
		margin-left: 3%;
		display: inline-block;
		width: 88%;
		height: 1px;
		border-bottom: 1px dashed #666;
		vertical-align: middle;
	}
	.pic_tip {
		font-size: 12px;
		color: #ff4949;
		line-height: 1px;
		padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
	}
	.pic_skan {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.pic_skan_red {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 2px solid #ff4a7d;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// financeInfo.vue?97d52ce2